export default "__VITE_ASSET__74452012__"